<template>
  <div id="invoice-payment-page">
    <vs-alert color="danger" :title="$t('InvoicePayNotifyTitle')" :active.sync="invoiceStatus">
      <span v-html="invoiceStatusText"></span>
    </vs-alert>

    <form-wizard v-if="!invoice_not_found && invoiceData && (invoiceData.IsPaymentRequired.Need || showTransaction)"
      ref="checkoutWizard" color="rgba(var(--vs-primary), 1)"
      :start-index="invoiceData.IsPaymentRequired.Need && showTransaction ? 2 : 1" :title="null" :subtitle="null"
      :hide-buttons="true">
      <tab-content :title="$t('Products')" icon="feather icon-list" class="mb-5">

        <div class="h-screen bg-img flex w-full vx-row no-gutter justify-center">
          <div class="vx-col sm:m-0 m-4">
            <div class="vx-row items-center justify-center" style="margin-bottom:7rem">
              <div class="vx-col w-full lg:w-1/4 md:w-1/2 sm:w-1/2 mt-10" style="min-width: 200px;"
                v-for="item in this.products" :key="item.InvoiceSettingGroupId"
                @click="$router.push('/paymentgroup/' + item.InvoiceSettingKey)">
                <vx-card class="text-center cursor-pointer">
                  <img src="https://portal.fsm.edu.tr/blank_logo.png" alt="graphic" width="100%" height="120" class="mb-6"
                    style="object-fit: scale-down;" />
                  <h5 class="mb-2">{{ item.ProductTitle }}</h5>
                </vx-card>
              </div>
            </div>
          </div>
        </div>
      </tab-content>
      <tab-content :title="$t('PaytoCC')" icon="feather icon-credit-card" class="mb-5"
        v-if="invoiceData.IsPaymentRequired.Need">
        <div class="vx-row">
          <div class="vx-col lg:w-2/3 w-full" v-if="loggedIn">
            <vx-card class="mb-base">
              <div class="the-navbar__user-meta flex items-center">
                <vs-dropdown vs-custom-content class="cursor-pointer">
                  <div class="con-img mr-3">
                    <vs-avatar :src="userInfo.Picture" size="40px" />
                  </div>
                  <vs-dropdown-menu class="vx-navbar-dropdown"></vs-dropdown-menu>
                </vs-dropdown>
                <div class="text-left leading-tight hidden sm:block">
                  <p class="font-semibold">{{ userInfo.FullName }}</p>
                  <small>{{ userInfo.Mail }}</small>
                </div>
                <vs-spacer></vs-spacer>
                <vs-button class="float-right vs-con-loading__container" icon-pack="feather" icon="icon-log-out"
                  color="warning" type="filled" @click="logout()">{{ $t('User.Logout') }}</vs-button>
              </div>
            </vx-card>

            <vx-card :title="$t('InvoiceAddressTitle')" class="mb-base">
              <ValidationObserver tag="form" ref="addressForm" v-on:submit.prevent v-slot="{ invalid }">
                <vs-alert color="warning" :title="$t('InvoicePayNotifyTitle')">
                  <span>{{ $t('InvoiceAddressDesc') }}</span>
                </vs-alert>
                
                <div class="vx-row mt-3">
                  <div class="vx-col w-full md:mb-2">
                    <label class="text-sm">{{ $t('Address.Style') }}</label>
                    <v-select :options="addressStyleOptions" :reduce="option => option.value"
                      v-model="addressData.UserAddressType" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-4 md:mb-0" />
                  </div>
                  <div class="vx-col w-full mb-2" v-if="addressData.UserAddressType != 1">
                    <ValidationProvider :name="$t('Address.IdentityNumber')" rules="required" v-slot="{ errors }">
                      <label class="text-sm">{{ $t('Address.IdentityNumber')}}</label>
                      <vs-input icon="icon icon-edit" icon-pack="feather"  autocomplete="off"
                        class="w-full no-icon-border card-input__input" v-model="addressData.IdentityNumber" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="vx-col w-full mb-2" v-if="addressData.UserAddressType == 1">
                    <ValidationProvider :name="$t('Address.Company')" rules="required" v-slot="{ errors }">
                      <label class="text-sm">{{ $t('Address.Company')}}</label>
                      <vs-input icon="icon icon-edit" icon-pack="feather" 
                        autocomplete="off" class="w-full no-icon-border card-input__input"
                        v-model="addressData.CompanyName" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="vx-col w-full mb-2 md:w-1/2" v-if="addressData.UserAddressType == 1">
                    <ValidationProvider :name="$t('Address.TaxNumber')" rules="required" v-slot="{ errors }">
                      <label class="text-sm">{{ $t('Address.TaxNumber')}}</label>
                      <vs-input icon="icon icon-edit" icon-pack="feather"  
                        autocomplete="off" class="w-full no-icon-border card-input__input"
                        v-model="addressData.TaxNumber" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="vx-col w-full mb-2 md:w-1/2" v-if="addressData.UserAddressType == 1">
                    <ValidationProvider :name="$t('Address.TaxAdmin')" rules="required" v-slot="{ errors }">
                      <label class="text-sm">{{ $t('Address.TaxAdmin')}}</label>
                      <vs-input icon="icon icon-edit" icon-pack="feather" 
                        autocomplete="off" class="w-full no-icon-border card-input__input"
                        v-model="addressData.TaxAdmin" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>

                  <div class="vx-col w-full mb-2">
                    <ValidationProvider :name="$t('Address.Address')" rules="required" v-slot="{ errors }">
                      <label class="text-sm">{{ $t('Address.Address')}}</label>
                      <vs-input icon="icon icon-edit" icon-pack="feather" 
                        autocomplete="off" class="w-full no-icon-border card-input__input"
                        v-model="addressData.Address" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-full md:w-1/3 md:mb-2">
                    <label class="text-sm">{{ $t('Address.City') }}</label>
                    <v-select :options="addressCitiesOptions" v-model="addressData.CityId" :clearable="false"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" />
                  </div>
                  <div class="vx-col w-full md:w-1/3 md:mb-2">
                    <label class="text-sm">{{ $t('Address.District') }}</label>
                    <ValidationProvider :name="$t('Address.District')" rules="required" v-slot="{ errors }">
                      <v-select :options="districts" v-model="addressData.DistrictId" :reduce="option => option.value"
                      :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-full md:w-1/3 md:mb-2">
                    <ValidationProvider :name="$t('Address.TaxCode')" rules="required" v-slot="{ errors }">
                    <label class="text-sm">{{ $t('Address.TaxCode') }}</label>
                    <vs-input icon="icon icon-edit" icon-pack="feather" 
                        autocomplete="off" class="w-full no-icon-border card-input__input"
                        v-model="addressData.TaxCode" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="vx-col w-full md:mb-base">
                    <label class="text-sm">{{ $t('Address.Type') }}</label>
                    <v-select :options="addressTypeOptions" v-model="addressData.EInvoice"
                      :reduce="option => option.value" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="mb-4 md:mb-0" />
                  </div>
                </div>
              </ValidationObserver>
            </vx-card>
            <vx-card :title="$t('InvoicePayPaymethodTitle')" :subtitle="$t('InvoicePayPaymethodDesc')" class="mb-base">
              <div class="vx-row mt-3">
                <div class="vx-col w-full md:w-1/2 sm:w-1/1 mb-base">
                  <ValidationObserver tag="form" ref="paymentForm" v-on:submit.prevent v-slot="{ invalid }">
                    <ValidationProvider :name="$t('Card.Name')" rules="required|min:3" v-slot="{ errors }">
                      <vs-input icon="icon icon-user" icon-pack="feather" :label-placeholder="$t('Card.Name')"
                        :id="fields.cardName" type="text" v-letter-only @input="changeName" data-card-field
                        autocomplete="off" class="w-full no-icon-border card-input__input" v-model="formData.cardName" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <ValidationProvider :name="$t('Card.Number')" rules="required|ccnumber" v-slot="{ errors }">
                      <vs-input type="tel" icon="icon icon-credit-card" icon-pack="feather"
                        :label-placeholder="$t('Card.Number')" :id="fields.cardNumber" @input="changeNumber"
                        @focus="focusCardNumber" @blur="blurCardNumber" data-card-field autocomplete="off"
                        :maxlength="cardNumberMaxLength" class="w-full no-icon-border card-input__input"
                        v-model="formData.cardNumber" />
                      <span class="text-danger text-sm">{{ errors[0] }}</span>
                    </ValidationProvider>

                    <div class="vx-row mt-5">
                      <div class="vx-col w-full md:w-1/3 sm:w-1/3 md:mb-base">
                        <label class="text-sm opacity-75">{{ $t('Card.Month') }}</label>
                        <v-select :id="fields.cardMonth" :options="cardMonthOptions" v-model="formData.cardMonth"
                          :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" @change="changeMonth"
                          data-card-field />
                      </div>
                      <div class="vx-col w-full md:w-1/3 sm:w-1/3 md:mb-base">
                        <label class="text-sm opacity-75">{{ $t('Card.Year') }}</label>
                        <v-select :id="fields.cardYear" :options="cardYearOptions" v-model="formData.cardYear"
                          :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="mb-4 md:mb-0" @change="changeYear"
                          data-card-field />
                      </div>
                      <div class="vx-col w-full md:w-1/5 sm:w-1/5 md:mb-base">
                        <ValidationProvider :name="$t('Card.CVV')" rules="required|min:3|max:4" v-slot="{ errors }">
                          <vs-input type="tel" :label-placeholder="$t('Card.CVV')" :id="fields.cardCvv" @input="changeCvv"
                            @blur="blurCardNumber" data-card-field autocomplete="off" v-number-only
                            class="w-full no-icon-border card-input__input mt-6" v-model="formData.cardCvv" />

                          <span class="text-danger text-sm">{{ errors[0] }}</span>
                        </ValidationProvider>
                      </div>
                    </div>
                  </ValidationObserver>
                </div>
                <div class="vx-col w-full md:w-1/2 sm:w-1/1 mb-base">
                  <Card :fields="fields" :labels="formData" :isCardNumberMasked="isCardNumberMasked"
                    :randomBackgrounds="false" />
                </div>
              </div>
            </vx-card>
          </div>

          <div v-if="!loggedIn" class="vx-col lg:w-2/3 w-full">
            <div class="vx-row">
              <div class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base">
                <vx-card v-if="!loginCard.student" class="text-center cursor-pointer" @click="selectLoginCard('student')">
                  <img src="@/assets/images/pages/graphic-2.png" alt="graphic" width="180" class="mx-auto mb-4" />
                  <h4 class="mb-2">{{ $t("Login.FormTitle") }}</h4>
                  <small>{{ $t("Login.FormDesc") }}</small>
                </vx-card>

                <vx-card v-if="loginCard.student" :title="$t('Login.FormTitle')" :subtitle="$t('Login.FormDesc')"
                  class="mb-base">
                  <div class="mt-3">
                    <ValidationObserver tag="form" ref="loginform" v-on:submit.prevent v-slot="{ invalid }">
                      <ValidationProvider :name="$t('Login.Username')" rules="required|min:3" v-slot="{ errors }">
                        <vs-input icon="icon icon-user" icon-pack="feather" :label-placeholder="$t('Login.Username')"
                          v-model="formDataLogin.Username" v-on:keyup.enter="login" class="w-full no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider :name="$t('Login.Password')" rules="required|min:3" v-slot="{ errors }">
                        <vs-input type="password" name="password" icon="icon icon-lock" v-on:keyup.enter="login"
                          icon-pack="feather" :label-placeholder="$t('Login.Password')" v-model="formDataLogin.Password"
                          ref="inputPassword" class="w-full mt-6 no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <br />
                      <vs-button class="loginButton vs-con-loading__container" :disabled="invalid" @click="login()">{{
                        $t('Login.LoginButton') }}</vs-button>
                    </ValidationObserver>
                  </div>
                </vx-card>
              </div>
              <div class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base">
                <vx-card v-if="!loginCard.personal" class="text-center cursor-pointer"
                  @click="selectLoginCard('personal')">
                  <img src="@/assets/images/pages/graphic-4.png" alt="graphic" width="180" class="mx-auto mb-4" />
                  <h4 class="mb-2">{{ $t("Login.FormTitle2") }}</h4>
                  <small>{{ $t("Login.FormDesc2") }}</small>
                </vx-card>
                <vx-card v-if="loginCard.personal" :title="$t('Login.FormTitle2')" :subtitle="$t('Login.FormDesc2')"
                  class="mb-base">
                  <div class="mt-3">
                    <ValidationObserver tag="form" ref="loginform" v-on:submit.prevent v-slot="{ invalid }">
                      <ValidationProvider :name="$t('Login.Username')" rules="required|min:3" v-slot="{ errors }">
                        <vs-input icon="icon icon-user" icon-pack="feather" :label-placeholder="$t('Login.Username')"
                          v-model="formDataLogin.Username" v-on:keyup.enter="login" class="w-full no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider :name="$t('Login.Password')" rules="required|min:3" v-slot="{ errors }">
                        <vs-input type="password" name="password" icon="icon icon-lock" v-on:keyup.enter="login"
                          icon-pack="feather" :label-placeholder="$t('Login.Password')" v-model="formDataLogin.Password"
                          ref="inputPassword" class="w-full mt-6 no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <br />
                      <vs-button class="loginButton vs-con-loading__container" :disabled="invalid" @click="login()">{{
                        $t('Login.LoginButton') }}</vs-button>
                    </ValidationObserver>
                  </div>
                </vx-card>
              </div>
              <div class="vx-col w-full md:w-1/3 sm:w-1/2 mb-base">
                <vx-card v-if="!loginCard.other" class="text-center cursor-pointer" @click="selectLoginCard('other')">
                  <img src="@/assets/images/pages/graphic-5.png" alt="graphic" width="180" class="mx-auto mb-4" />
                  <h4 class="mb-2">{{ $t("Login.FormTitle3") }}</h4>
                  <small>{{ $t("Login.FormDesc3") }}</small>
                </vx-card>
                <vx-card v-if="loginCard.other" :title="$t('Login.FormTitle3')" :subtitle="$t('Login.FormDesc3')"
                  class="mb-base">
                  <div class="mt-3">
                    <ValidationObserver tag="form" ref="loginformOther" v-on:submit.prevent v-slot="{ invalid }">
                      <ValidationProvider :name="$t('Login.OtherIdentityNumber')" rules="required|identityNumber"
                        v-slot="{ errors }">
                        <vs-input icon="icon icon-lock" icon-pack="feather"
                          :label-placeholder="$t('Login.OtherIdentityNumber')" v-model="formDataLoginOther.IdentityNumber"
                          v-on:keyup.enter="loginOther" class="w-full no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider :name="$t('Login.OtherName')" rules="required|min:3" v-slot="{ errors }">
                        <vs-input icon="icon icon-user" icon-pack="feather" :label-placeholder="$t('Login.OtherName')"
                          v-model="formDataLoginOther.FullName" v-on:keyup.enter="loginOther"
                          class="w-full no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider :name="$t('Login.OtherMail')" rules="required|email" v-slot="{ errors }">
                        <vs-input icon="icon icon-mail" icon-pack="feather" :label-placeholder="$t('Login.OtherMail')"
                          v-model="formDataLoginOther.Email" v-on:keyup.enter="loginOther"
                          class="w-full no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <ValidationProvider :name="$t('Login.OtherPhone')" rules="required|numeric|min:10|max:12"
                        v-slot="{ errors }">
                        <vs-input icon="icon icon-phone" icon-pack="feather" :label-placeholder="$t('Login.OtherPhone')"
                          v-model="formDataLoginOther.Phone" v-on:keyup.enter="loginOther"
                          class="w-full no-icon-border" />
                        <span class="text-danger text-sm">{{ errors[0] }}</span>
                      </ValidationProvider>

                      <br />
                      <vs-button class="loginButton vs-con-loading__container" :disabled="invalid"
                        @click="loginOther()">{{ $t('Login.LoginButton') }}</vs-button>
                    </ValidationObserver>
                  </div>
                </vx-card>
              </div>
            </div>
          </div>
          <div class="vx-col lg:w-1/3 w-full">
            <vx-card :title="$t('InvoicePayInfo')" class="mb-base">
              <div class="flex justify-between mb-2">
                <span>
                  {{ invoiceData.SettingGroup.ProductTitle }}
                  <span v-if="invoiceData.SettingGroup.ProductDesc">({{ invoiceData.SettingGroup.ProductDesc }})</span>
                </span>
                <span class="font-semibold">{{ invoiceData.SettingGroup.Price | currency }}</span>
              </div>

              <div v-if="invoiceData.AvailableDiscounts && invoiceData.AvailableDiscounts.length > 0">
                <div class="flex justify-between mb-2" v-for="discount in invoiceData.AvailableDiscounts"
                  v-bind:key="discount.RuleID">
                  <span>{{ discount.DiscountDesc }}</span>
                  <span class="text-danger">-{{ calculateDiscount(discount) | currency }}</span>
                </div>
              </div>
              <div class="flex justify-between mb-2" v-if="payFormData.Installment > 1 && selectedInstallmentData.Index">
                <span>{{ $t('InvoicePayInstallmentPrice', { index: payFormData.Installment }) }}</span>
                <span class="text-success">+{{ (invoiceData.IsPaymentRequired.Amount - selectedInstallmentData.TotalPrice)
                  |
                  currency }}</span>
              </div>

              <div v-if="invoiceData.PaidAmount" class="flex justify-between mb-2">
                <span>{{ $t('InvoicePayPaidAmount') }}</span>
                <span class="text-danger">-{{ invoiceData.PaidAmount | currency }}</span>
              </div>

              <vs-divider />

              <div class="flex justify-between">
                <span>{{ $t('InvoicePayAmount') }}</span>
                <span class="font-semibold">{{ cartPrice | currency }}</span>
              </div>
            </vx-card>

            <vx-card v-if="loggedIn" :title="$t('InvoicePayInstallment')">
              <div class="mt-3">
                <img
                  v-if="invoiceInstallments && invoiceInstallments.Installments && invoiceInstallments.Installments.length > 0 && invoiceInstallments.Logo"
                  :src="invoiceInstallments.Logo" alt="bank-logo" class="float-right inline-flex brand-image" />

                <ul>
                  <li class="mb-3">
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio vs-value="1" v-model="payFormData.Installment">
                        <div class="flex items-center">
                          <span class="ml-5">
                            {{ $t('InvoicePayInstallment1') }} :
                            <b>{{ invoiceData.IsPaymentRequired.Amount | currency }}</b>
                          </span>
                        </div>
                      </vs-radio>
                    </div>
                  </li>
                  <li class="mb-3" v-for="installement in invoiceInstallments.Installments" :key="installement.Index">
                    <div class="flex flex-wrap justify-between items-center">
                      <vs-radio :vs-value="installement.Index" v-model="payFormData.Installment">
                        <div class="flex items-center">
                          <span class="ml-5">
                            {{ installement.Index }} {{ $t('InvoicePayInstallment2') }}
                            <b>{{ installement.MonthlyPrice | currency }}</b>
                            {{ $t('InvoicePayInstallment3') }}:
                            <b>{{ installement.TotalPrice | currency }}</b>
                          </span>
                        </div>
                      </vs-radio>
                    </div>
                  </li>
                </ul>
              </div>
            </vx-card>

            <br />

            <vs-button v-if="loggedIn" class="w-full paymentSubmit vs-con-loading__container" size="large"
              @click="doPayment()" color="success" type="filled" icon-pack="feather" icon="icon-shopping-cart">{{
                $t('Card.Payment') }}</vs-button>
          </div>
        </div>
      </tab-content>
      <tab-content :title="$t('PaytoSummary')" icon="feather icon-printer" class="mb-5">
        <vs-alert :color="Transaction.TransactionState != 0 ? 'danger' : 'success'" :title="$t('InvoicePayNotifyTitle')"
          :active.sync="showTransaction">
          <span>{{ transactionResponse(Transaction) }}</span>

          <span v-if="Transaction.TransactionState == 0 && invoiceData.IsPaymentRequired.Need"
            @click="$refs.checkoutWizard.prevTab()" class="text-inherit underline cursor-pointer">
            <br />
            <br />
            {{ $t('Transactions.Need', {
              amount: (this.$options.filters.currency(invoiceData.IsPaymentRequired.Amount))
            }) }}
          </span>
          <span v-if="Transaction.TransactionState == 5 && invoiceData.IsPaymentRequired.Need"
            @click="$refs.checkoutWizard.prevTab()" class="text-inherit underline cursor-pointer">
            <br />
            <br />
            {{ $t('TryAgain') }}
          </span>
        </vs-alert>
      </tab-content>
    </form-wizard>

    <form ref="threeDRedirectForm" method="post" :action="threeDInfo.AcsUrl">
      <input type="hidden" name="PaReq" :value="threeDInfo.PAReq" />
      <input type="hidden" name="TermUrl" :value="threeDInfo.TermUrl" />
      <input type="hidden" name="MD" :value="threeDInfo.MD" />
    </form>
    <form ref="threeDRedirectFormHidden" method="post" :action="threeDInfo.AcsUrl">
      <input v-for="(val, key) in threeDInfo.Model" :key="key" type="hidden" :name="key" :value="val" />
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import _ from 'lodash';
import InvoiceApi from "@/api/invoice";
import { FormWizard, TabContent } from "vue-form-wizard";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import vSelect from "vue-select";

import Card from "@/components/Card.vue";

var cardValid = require("card-validator");

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

export default {
  components: {
    FormWizard,
    TabContent,
    ValidationProvider,
    ValidationObserver,
    Card,
    vSelect
  },
  data() {
    return {
      showTransaction: false,
      Transaction: {},
      products: [],
      threeDInfo: {
        AcsUrl: "",
        PAReq: "",
        TermUrl: "",
        MD: "",
        Model: {}
      },
      binBusy: false,
      checkBinAvailable: true,
      lastBinCN: "",
      invoiceInstallments: [],
      cartPrice: 0,
      cities: [],
      districts: [],
      addressData: {
        ExtendUserId: null,
        UserAddressType: 0,
        CityId: null,
        DistrictId: null,
        Address: "",
        CompanyName: "",
        TaxAdmin: "",
        TaxNumber: "",
        TaxCode: "",
        EInvoice: 0
      },
      formData: {
        cardName: "",
        cardNumber: "",
        cardMonth: { label: "Ay", value: "" },
        cardYear: { label: "Yıl", value: "" },
        cardCvv: ""
      },
      payFormData: {
        Paymethod: "VakifbankClassic",
        InvoiceKey: "",
        CardOwner: "",
        CardNumber: "",
        CardMonth: "",
        CardYear: "",
        CardCvv: "",
        Installment: 1
      },
      selectedInstallmentData: {},
      fields: {
        cardNumber: "v-card-number",
        cardName: "v-card-name",
        cardMonth: "v-card-month",
        cardYear: "v-card-year",
        cardCvv: "v-card-cvv"
      },
      minCardYear: new Date().getFullYear(),
      isCardNumberMasked: true,
      mainCardNumber: this.cardNumber,
      cardNumberMaxLength: 19,
      fetchLoaded: false,
      loginCard: {
        student: false,
        personal: false,
        other: false
      },
      formDataLogin: {
        Username: "",
        Password: "",
        RememberMe: true,
        GoogleReCaptchaResponse: ""
      },
      formDataLoginOther: {
        IdentityNumber: "",
        FullName: "",
        Email: "",
        Phone: ""
      },
      submitBusy: false,
      invoiceData: null,
      lastAccountsData: {},
      invoice_not_found: false,
      accounts: [],
      submitBusy: false,
      logged: false,
      expiryOptions: [],
      cardMonthOptions: [
        { label: "Ay", value: "" },
        { label: "1", value: "01" },
        { label: "2", value: "02" },
        { label: "3", value: "03" },
        { label: "4", value: "04" },
        { label: "5", value: "05" },
        { label: "6", value: "06" },
        { label: "7", value: "07" },
        { label: "8", value: "08" },
        { label: "9", value: "09" },
        { label: "10", value: "10" },
        { label: "11", value: "11" },
        { label: "12", value: "12" }
      ]
    };
  },
  directives: {
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      }
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      }
    }
  },
  watch: {
    addressData: {
      handler: _.debounce(function (v) {
        if (this.fetchLoaded && this.invoiceData)
        InvoiceApi.saveUserAddress({ InvoiceId: this.invoiceData.Invoice.InvoiceID, ...this.addressData });
      }, 500)
      , deep: true
    },
    "addressData.CityId"(v) {
      this.districts = [];
      if (this.fetchLoaded)
      this.addressData.DistrictId = null;

      v.districts.map(e => {
        this.districts.push({
          label: e.DistrictName,
          value: e.DistrictId
        });
      });
    },
    "payFormData.Installment"() {
      if (this.payFormData.Installment <= 1) {
        this.cartPrice = this.invoiceData.IsPaymentRequired.Amount || 0;
        this.selectedInstallmentData = {};
      } else {
        var vm = this;
        var installementData = this.invoiceInstallments.Installments.find(
          x => x.Index == vm.payFormData.Installment
        );

        if (installementData) {
          this.cartPrice = installementData.TotalPrice;
          this.selectedInstallmentData = installementData;
        }
      }
    },
    cardYear() {
      if (this.formData.cardMonth < this.minCardMonth) {
        this.formData.cardMonth = "";
      }
    }
  },
  computed: {
    cardYearOptions() {
      var items = [{ label: this.$t("Card.Year"), value: "" }];
      for (let index = 0; index <= 12; index++) {
        items.push({
          label: index + this.minCardYear,
          value: index + this.minCardYear
        });
      }
      return items;
    },
    addressStyleOptions() {
      return [{ label: this.$t("Address.Style1"), value: 0 }, { label: this.$t("Address.Style2"), value: 1 }];
    },
    addressTypeOptions() {
      return [{ label: this.$t("Address.Type1"), value: 0 }, { label: this.$t("Address.Type2"), value: 1 }];
    },
    addressCitiesOptions() {
      var items = [];
      this.cities.map(e => {
        items.push({
          label: e.CityName,
          value: e.CityId,
          districts: e.Districts
        });
      });
      return items;
    },
    minCardMonth() {
      if (this.formData.cardYear === this.minCardYear)
        return new Date().getMonth() + 1;
      return 1;
    },
    loggedIn() {
      this.logged;
      return (this.logged = this.$store.state.auth.isUserLoggedIn());
    },
    userInfo() {
      this.logged;
      if (
        $cookies.isKey(process.env.VUE_APP_COOKIE_AUTH_UI) &&
        this.$auth.isAuthenticated()
      ) {
        return $cookies.get(process.env.VUE_APP_COOKIE_AUTH_UI);
      } else {
        return {};
      }
    },
    invoiceStatus() {
      return (
        this.invoice_not_found ||
        (this.invoiceData != null &&
          !this.invoiceData.IsPaymentRequired.Need &&
          !this.showTransaction)
      );
    },
    invoiceStatusText() {
      if (this.invoice_not_found) {
        return this.$t("InvoicePayNotFound", {
          invoiceId: this.$route.params.invoiceId
        });
      } else if (
        this.invoiceData != null &&
        !this.invoiceData.IsPaymentRequired.Need
      ) {

        return this.$t("InvoicePayNeedPay", {
          invoiceId: this.$route.params.invoiceId,
          key: this.invoiceData.SettingGroup.InvoiceSettingKey
        });
      }
    }
  },
  methods: {
    handleLocaleEvent() {
      this.formData.cardMonth = { label: this.$t("Card.Month"), value: "" };
      this.formData.cardYear = { label: this.$t("Card.Year"), value: "" };
    },
    calculateDiscount(discount) {
      var discountPrice = 0;
      if (discount.DiscountRate > 0)
        discountPrice =
          (discount.DiscountRate * this.invoiceData.Invoice.InvoicePrice) / 100;
      if (discount.DiscountPrice > 0) discountPrice += discount.DiscountPrice;

      return discountPrice;
    },
    transactionResponse(transaction) {
      if (transaction) {
        switch (transaction.TransactionState) {
          case 0:
            return this.$t("Transactions.T0");
            break;
          case 1:
            return this.$t("Transactions.T1");
            break;
          case 2:
            return this.$t("Transactions.T2");
            break;
          case 3:
            return this.$t("Transactions.T3");
            break;
          case 4:
            return this.$t("Transactions.T4");
            break;
          case 5:
            return transaction.Response;
            break;
        }
      }
    },
    async doPayment() {
      const isValid = await this.$refs.paymentForm.validate();
      const isvalidAddress = await this.$refs.addressForm.validate();

      if (this.submitBusy || !isValid || !isvalidAddress) return;

      if (!this.formData.cardYear.value || !this.formData.cardMonth.value) {
        this.$vs.notify({
          time: 2500,
          title: this.$t("Warning"),
          text: this.$t("Card.ExpireDateWarning"),
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-right"
        });
        return;
      } else {
        var expiryValidation = cardValid.expirationDate({
          month: this.formData.cardMonth.value,
          year: this.formData.cardYear.value
        });
        if (!expiryValidation.isPotentiallyValid) {
          this.$vs.notify({
            time: 2500,
            title: this.$t("Warning"),
            text: this.$t("Card.ExpireDateDanger"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
            position: "top-right"
          });

          return;
        }
      }

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: ".paymentSubmit",
        scale: 0.45
      });

      try {
        this.payFormData.InvoiceKey = this.$route.params.invoiceId.toString();
        this.payFormData.CardOwner = this.formData.cardName;
        this.payFormData.CardMonth = this.formData.cardMonth.value.toString();
        this.payFormData.CardYear = this.formData.cardYear.value.toString();
        this.payFormData.Installment = this.payFormData.Installment.toString();

        let payResponse = await InvoiceApi.doPayment(this.payFormData, this);

        if (!payResponse.data.error && !payResponse.data.errors) {
          if (!payResponse.data.HiddenForm) {
            this.threeDInfo.AcsUrl = payResponse.data.AcsUrl;
            this.threeDInfo.PAReq = payResponse.data.PAReq;
            this.threeDInfo.TermUrl = payResponse.data.TermUrl;
            this.threeDInfo.MD = payResponse.data.MD;

            setTimeout(() => {
              this.$refs.threeDRedirectForm.submit();
            }, 100);
          } else {
            this.threeDInfo.AcsUrl = payResponse.data.AcsUrl;
            this.threeDInfo.Model = payResponse.data.Model;

            setTimeout(() => {
              this.$refs.threeDRedirectFormHidden.submit();
            }, 100);
          }
        }
      } finally {
        this.submitBusy = false;
      }
    },
    async logout() {
      if (this.loggedIn) {
        this.$auth.logOut();
        this.logged = false;
        this.payFormData.Installment = 1;
        this.cartPrice = this.invoiceData.IsPaymentRequired.Amount || 0;
        this.selectedInstallmentData = {};

        this.checkBinAvailable = true;
        this.lastBinCN = "";
        this.invoiceInstallments = [];
        this.cartPrice = 0;
        this.formData = {
          cardName: "",
          cardNumber: "",
          cardMonth: { label: this.$t("Card.Month"), value: "" },
          cardYear: { label: this.$t("Card.Year"), value: "" },
          cardCvv: ""
        };
        this.payFormData = {
          Paymethod: "VakifbankClassic",
          InvoiceKey: "",
          CardOwner: "",
          CardNumber: "",
          CardMonth: "",
          CardYear: "",
          CardCvv: "",
          Installment: 1
        }; 
        this.addressData =  {
          ExtendUserId: null,
          UserAddressType: 0,
          CityId: null,
          DistrictId: null,
          Address: "",
          CompanyName: "",
          TaxAdmin: "",
          TaxNumber: "",
          TaxCode: "",
          EInvoice: 0
        };

        this.mainCardNumber = "";

        await this.fetchLoadData();
      }
    },
    selectLoginCard(card) {
      this.loginCard.student = false;
      this.loginCard.personal = false;
      this.loginCard.other = false;

      switch (card) {
        case "personal":
          this.loginCard.personal = true;
          break;
        case "student":
          this.loginCard.student = true;
          break;
        case "other":
          this.loginCard.other = true;
          break;
      }
    },
    async login() {
      const isValid = await this.$refs.loginform.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: ".loginButton",
        scale: 0.45
      });
      try {
        this.$recaptcha("login").then(async token => {
          this.formDataLogin.GoogleReCaptchaResponse = token;
          await this.$auth.login(this.formDataLogin, this);

          let setUserData = {
            InvoiceKey: this.$route.params.invoiceId.toString(),
            LocalUser: true
          };
          let setUserResult = await InvoiceApi.setUser(setUserData, this);

          if (!setUserResult.data.error && !setUserResult.data.errors) {
            this.logged = true;
            this.formDataLogin.Password = "";

            if (setUserResult.data.redirect)
              window.location.assign(setUserResult.data.redirect);
          } else {
            this.$auth.logOut();
            this.logged = false;
          }
          await this.fetchLoadData();
        });
      } finally {
        this.submitBusy = false;
      }
    },

    async loginOther() {
      const isValid = await this.$refs.loginformOther.validate();
      if (this.submitBusy || !isValid) return;

      this.submitBusy = true;
      this.$vs.loading({
        color: "#000",
        container: ".loginButton",
        scale: 0.45
      });
      try {
        let setUserData = {
          InvoiceKey: this.$route.params.invoiceId.toString(),
          LocalUser: false,
          IdentityNumber: this.formDataLoginOther.IdentityNumber.toString(),
          FullName: this.formDataLoginOther.FullName.toString(),
          Email: this.formDataLoginOther.Email.toString(),
          Phone: this.formDataLoginOther.Phone.toString()
        };
        let setUserResult = await InvoiceApi.setUser(setUserData, this);
        this.$auth.logOut();

        if (!setUserResult.data.error && !setUserResult.data.errors) {
          this.$auth.localLogin(setUserResult.data);
          this.logged = true;
          if (setUserResult.data.redirect)
            window.location.assign(setUserResult.data.redirect);
        } else {
          this.logged = false;
        }
        await this.fetchLoadData();
      } finally {
        this.submitBusy = false;
      }
    },

    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        scale: 0.45
      });
      this.fetchLoaded = false;

      const invoiceId = this.$route.params.invoiceId;
      const transactionId = this.$route.params.transactionId;

      var invoiceResult = await InvoiceApi.getInvoice(
        { InvoiceKey: invoiceId },
        this
      );

      if (!invoiceResult.data.error) {
        this.invoiceData = invoiceResult.data;
        this.cartPrice = this.invoiceData.IsPaymentRequired.Amount || 0;

        if (transactionId && transactionId > 0) {
          var checkTransaction = this.invoiceData.Invoice.Transactions.find(
            x => x.TransactionID == transactionId
          );

          if (checkTransaction) {
            this.showTransaction = true;
            this.Transaction = checkTransaction;
          } else this.invoice_not_found = true;
        }

        var productResult = await InvoiceApi.getProducts(
          { Slug: this.invoiceData.RoleGroup.RoleGroupName },
          this
        );

        if (productResult.data.success) {
          this.products = productResult.data.model;

          const cities = await InvoiceApi.getCities();
          if (!cities.data.error) {
            this.cities = cities.data;
          }

          const address = await InvoiceApi.getUserAddress({ InvoiceId: this.invoiceData.Invoice.InvoiceID });
          if (!address.data.error) {
            var findCity = this.cities.find(c => c.Districts.some(d => d.DistrictId == address.data.DistrictId));
            var cityId = findCity ? { value: findCity.CityId, label: findCity.CityName, districts: findCity.Districts} : null;

            address.data.EInvoice = address.data.EInvoice ? 1 : 0;

            this.addressData = { CityId: cityId, ...address.data };
          }
        }

      } else this.invoice_not_found = true;

      setTimeout(() => {
        try {
          this.$vs.loading.close();
          this.fetchLoaded = true;
        } catch { }
      }, 100);
    },
    generateMonthValue(n) {
      return n < 10 ? `0${n}` : n;
    },
    changeName(e) {
      this.$emit("input-card-name", this.formData.cardName);
    },
    async changeNumber(e) {
      let value = this.formData.cardNumber.replace(/\D/g, "");
      this.payFormData.CardNumber = value;
      // american express, 15 digits
      if (/^3[47]\d{0,13}$/.test(value)) {
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 17;
      } else if (/^3(?:0[0-5]|[68]\d)\d{0,11}$/.test(value)) {
        // diner's club, 14 digits
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{6})/, "$1 $2 ");
        this.cardNumberMaxLength = 16;
      } else if (/^\d{0,16}$/.test(value)) {
        // regular cc number, 16 digits
        this.formData.cardNumber = value
          .replace(/(\d{4})/, "$1 ")
          .replace(/(\d{4}) (\d{4})/, "$1 $2 ")
          .replace(/(\d{4}) (\d{4}) (\d{4})/, "$1 $2 $3 ");
        this.cardNumberMaxLength = 19;
      }
      this.$emit("input-card-number", this.formData.cardNumber);

      if (value.length >= 6 && this.lastBinCN != value.substring(0, 6)) {
        this.invoiceInstallments = [];
        this.checkBinAvailable = true;
      }

      if (this.checkBinAvailable && value.length >= 6) {
        this.checkBinAvailable = false;
        this.binBusy = true;
        let binResult = await InvoiceApi.getBin({
          InvoiceKey: this.$route.params.invoiceId.toString(),
          cardNumber: value
        });

        if (!binResult.data.error) {
          if (binResult.data.Installments)
            this.invoiceInstallments = binResult.data;
        }

        this.lastBinCN = value.substring(0, 6);
        this.binBusy = false;
      } else if (value.length < 6) {
        this.checkBinAvailable = true;
        this.invoiceInstallments = [];
        this.lastBinCN = "";
        this.payFormData.Installment = 1;
      }
    },
    changeMonth() {
      this.payFormData.CardMonth = this.formData.cardMonth;
      this.$emit("input-card-month", this.formData.cardMonth);
    },
    changeYear() {
      this.payFormData.CardYear = this.formData.cardYear;
      this.$emit("input-card-year", this.formData.cardYear);
    },
    changeCvv(e) {
      this.payFormData.CardCvv = this.formData.cardCvv;
      this.$emit("input-card-cvv", this.formData.cardCvv);
    },
    invaildCard() {
      let number = this.formData.cardNumber;
      let sum = 0;
      let isOdd = true;
      for (let i = number.length - 1; i >= 0; i--) {
        let num = number.charAt(i);
        if (isOdd) {
          sum += num;
        } else {
          num = num * 2;
          if (num > 9) {
            num = num
              .toString()
              .split("")
              .join("+");
          }
          sum += num;
        }
        isOdd = !isOdd;
      }
      if (sum % 10 !== 0) {
        alert("invaild card number");
      }
    },
    blurCardNumber() {
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      }
    },
    maskCardNumber() {
      return (this.mainCardNumber = this.formData.cardNumber);
    },
    unMaskCardNumber() {
      this.formData.cardNumber = this.mainCardNumber;
    },
    focusCardNumber() {
      this.unMaskCardNumber();
    },
    toggleMask() {
      this.isCardNumberMasked = !this.isCardNumberMasked;
      if (this.isCardNumberMasked) {
        this.maskCardNumber();
      } else {
        this.unMaskCardNumber();
      }
    }
  },
  created() {
    this.handleLocaleEvent();
  },
  async mounted() {
    if (this.loggedIn) {
      var token = this.userInfo.Token;
      if (token && token == "LocalUser") {
        let setUserData = {
          InvoiceKey: this.$route.params.invoiceId.toString(),
          LocalUser: false,
          IdentityNumber: this.userInfo.Username.toString(),
          FullName: this.userInfo.FullName.toString(),
          Email: this.userInfo.Mail.toString(),
          Phone: this.userInfo.Phone.toString()
        };
        let setUserResult = await InvoiceApi.setUser(setUserData, this);
        this.$auth.logOut();

        if (!setUserResult.data.error && !setUserResult.data.errors) {
          this.$auth.localLogin(setUserResult.data);
          this.logged = true;
          if (setUserResult.data.redirect)
            window.location.assign(setUserResult.data.redirect);
        } else {
          this.logged = false;
        }
      } else {
        let setUserData = {
          InvoiceKey: this.$route.params.invoiceId.toString(),
          LocalUser: true
        };
        let setUserResult = await InvoiceApi.setUser(setUserData, this);

        if (!setUserResult.data.error && !setUserResult.data.errors) {
          this.logged = true;
          this.formDataLogin.Password = "";
          if (setUserResult.data.redirect)
            window.location.assign(setUserResult.data.redirect);
        } else {
          this.$auth.logOut();
          this.logged = false;
        }
      }
    }
    this.fetchLoadData();
    this.maskCardNumber();
  }
};
</script>
<style lang="scss">
.wizard-navigation {
  margin-bottom: 12%;
}
</style>
  
<style lang="scss" scoped>
.vs-input--placeholder{
  color: black;
  font-weight: 600;
}

#invoice-payment-page {
  .vue-form-wizard {
    padding-bottom: 0;

    ::v-deep .wizard-header {
      padding: 0;
    }

    ::v-deep .wizard-tab-content {
      padding-right: 0;
      padding-left: 0;
      padding-bottom: 0;

      .wizard-tab-container {
        margin-bottom: 0 !important;
      }
    }
  }

  .brand-image {
    width: 150px;
    object-fit: cover;
  }
}
</style>
